// extracted by mini-css-extract-plugin
module.exports = {"scrollWrap":"scrollWrap_2_aRau6l","loadingWrapper":"loadingWrapper_lD4ZxLnD"};